import { useDocumentVisibleOnce } from '@domains/pdp-common';

import { TopRecommendList } from '../components/TopRecommendList';
import { useTopRecommendListService } from '../services/useTopRecommendListService';

interface TopRecommendListContainerProps {
  productId: string;
}

export const TopRecommendListContainer = ({ productId }: TopRecommendListContainerProps) => {
  const { ref } = useDocumentVisibleOnce({ disableUntilScroll: true });
  const { isHide, list, onImpressionProduct, onClickProduct, onSavedProduct } = useTopRecommendListService({
    productId,
  });

  if (isHide) {
    return null;
  }

  return (
    <div ref={ref}>
      <TopRecommendList
        list={list}
        onImpressionProduct={onImpressionProduct}
        onClickProduct={onClickProduct}
        onSaveProduct={onSavedProduct}
      />
    </div>
  );
};
